export default "__VITE_ASSET__B48Dof9V__"